import { Injectable } from '@angular/core';
import { WorkItemAdapter } from '../workitem-adapter';
import { bcSessionKeys } from 'common/common/constants/session-keys';
import { WorkItemComposeEmail } from '../models/workitem-compose-email-model';
import { CoolLocalStorage } from '@angular-cool/storage';
import { LoginSubscriber } from 'shared/services/subscribers/login-subscriber.service';
import { LogoutSubscriber } from 'shared/services/subscribers/logout-subscriber.service';

const NUMBER_OF_EMAIL_COMPOSE_ELEMENTS = 1;

@Injectable()
export class ComposeEmailList {
  private _emailComposeWorkItems: WorkItemComposeEmail[] = [];

  constructor(private localStorageService: CoolLocalStorage,
              loginSubscriber: LoginSubscriber,
              logoutSubscriber: LogoutSubscriber) {
    logoutSubscriber.subscribe(this.resetComposeEmail.bind(this));
    loginSubscriber.subscribe(this.loadEmailComposeItems.bind(this));
  }

  loadEmailComposeItems() {
    const savedEmailComposeWorkItemList = JSON.parse(this.localStorageService.getItem(bcSessionKeys.storage.emailComposeWorkItem));
    if (savedEmailComposeWorkItemList && savedEmailComposeWorkItemList.length > 0) {
      this._emailComposeWorkItems.push(WorkItemAdapter.createEmailComposeWorkItem(savedEmailComposeWorkItemList[0]));
    }
  }

  get canComposeMoreEmails() {
    return this._emailComposeWorkItems.length < NUMBER_OF_EMAIL_COMPOSE_ELEMENTS;
  }

  // TODO: this follows the current logic: if you have an email compose element then you can't make an other one
  // Maybe this can be fixed during https://jira.3amlabs.net/browse/IG-4130 (Unless draft saving won't work on more than one element
  get actualEmailComposeWorkItem(): WorkItemComposeEmail {
    return this._emailComposeWorkItems[0];
  }

  get emailComposeWorkItems() {
    return this._emailComposeWorkItems;
  }

  createEmailComposeElement(): WorkItemComposeEmail {
    if (!this.canComposeMoreEmails) {
      return undefined;
    }

    const workItem = <WorkItemComposeEmail>WorkItemAdapter.createEmailComposeWorkItem();

    this._emailComposeWorkItems.push(workItem);
    this.updateEmailComposeStorage();

    return workItem;
  }

  resetComposeEmail() {
    this._emailComposeWorkItems = [];
    this.updateEmailComposeStorage();
  }

  public updateEmailComposeStorage() {
    if (this._emailComposeWorkItems.length > 0) {
      this.localStorageService.setItem(bcSessionKeys.storage.emailComposeWorkItem, JSON.stringify(this._emailComposeWorkItems));
    } else {
      this.localStorageService.removeItem(bcSessionKeys.storage.emailComposeWorkItem);
    }
  }
}
